define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/arr.js
// module id = 48
// module chunks = 0